import React, { Component } from "react";
import ReactTable from "react-table";
import './pivottable.css';
import service from '../../services/api/Common'


// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Button,
  FormGroup,
  Input,
  InputGroup,
  InputGroupButtonDropdown,
  Row,
  Collapse,
  DropdownToggle,
  Badge,
  Table,
  ModalHeader,
  ModalBody,
  Modal,
  DropdownMenu, DropdownItem, UncontrolledDropdown,
} from "reactstrap";
import {
  Link
} from "react-router-dom";
import {imageFileExtension,getImageFile,getRandomRolor,saveDownloadFile,millisecondToHour, jobStatusAlert, addDisableScroll, removeDisableScroll} from "../../settings/shared/commonMethod"
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import 'react-web-tabs/dist/react-web-tabs.css';

import { toast } from 'react-toastify';
import Dialog from 'react-dialog'
import constants, {
  INTERVALSEARCH,
  RUN_PROGRESS_STATUS
} from '../../settings/shared/constants';
import 'react-dialog/css/index.css'
import moment from 'moment'
import RunService from '../../services/api/Run';
import UserService from '../../services/api/User';
import ChatService from '../../services/api/Chat';
import ProjectService from '../../services/api/Project';
import HashLoader from "react-spinners/HashLoader";
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay'
import { Scrollbars } from 'react-custom-scrollbars';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { Launcher } from '../../components/Chat/';
import { jobidLoad } from '../../components/Chat/UserInput';
import { projectLoad } from '../../components/Chat/UserInput';

import StorageService from '../../services/api/Storage';

// simplest method: uses precompiled complete bundle from `plotly.js`
import Plot from 'react-plotly.js';
// customizable method: use your own `Plotly` object
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';

import TableRenderers from 'react-pivottable/TableRenderers';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import TinyURL from "tinyurl";
import Chip from '@material-ui/core/Chip';
import openpara from "assets/img/open.png";
import Pagination from "../../assets/js/Pagination";
import { AsyncPaginate } from 'react-select-async-paginate';
import ChipInput from 'material-ui-chip-input';
import axios from 'axios'
import Autosuggest from "react-autosuggest";
import { uuidv4 } from '../../components/Notebook/operations/notebook'
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-python';
import Catalog from "../Catalog/Catalog";


// create Plotly renderers via dependency injection
const PlotlyRenderers = createPlotlyRenderers(Plot);

const colours=['red', 'orange', 'yellow','blue', 'green', 'indigo', 'violet'];


const styles = {
  chaticon: {
    cursor: 'pointer'
  },
  chatbutton: {
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    boxShadow: 'transparent',
  },
  expandStyles: {
    backgroundColor: "#ffffff",
    fontSize: "0.8rem",
    letterSpacing: 1
  },
  expandStyles_Comman: {
    backgroundColor: "#000000",
    color: "#2dce89",
    fontSize: "0.2rem",
    letterSpacing: 1,
    width: 550,
    height: 'auto',
    // maxHeight:400,
    marginTop: 5,
    marginLeft: 30,
    marginBottom: 2
  },
  expandStyles_param: {
    fontSize: "0.8rem",
    letterSpacing: 1,
    width: 550,
    marginTop: 5,
    marginLeft: 30
  },
  logbtn: {
    backgroundColor: "#5e72e4",
    color: "#ffffff",
    fontSize: "0.8rem",
    letterSpacing: 1,
    borderRadius: 8,
    height: 30,
    width: 50,
    padding: 0,
    marginLeft: 10
  },
  removedialog: {
    top: '50%',
    width: '250px'
  },
  error:{
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    // padding: "6px 200px 6px 250px",
    borderRadius:6
  },
}

function getSuggestionValue(suggestion) {
  return suggestion.name;
}

function renderSuggestion(suggestion) {
  return (
    <span>{suggestion.name}</span>
  );
}


class ViewProject extends Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.searchTimeOut = 0;
    this.onPageChange = this.onPageChange.bind(this);
    this.state = {
      pivotState: props,
      openedCollapses: ["collapseOne", "collapseTwo", "collapseTwoCompare", "collapseTwoCompareTable"],
      dropdownOpen: false,
      input: "",
      input_user: [],
      input_userEmail: [],
      messages: [],
      open: false,
      products: [],
      columns: [],
      chatMsg: [],
      messageList:[],
      runOptions: [],
      filtered:[],
      commonOptions: [],
      updatePageNumber:0,
      totalPages:0,
      tableCompareFlag: false,
      tableCompareData:[],
      commonOptionsCompare: [],
      localName: null,
      localPhoto: null,
      chatDbId: null,
      socketLoadFlag: false,
      steptwoFlag: false,
      graphFlag: false,
      graphFlag_Loading: false,
      graphText: '',
      logState: false,
      runname: "",
      viewId: "",
      viewname: "",
      delimiter: "",
      chooseRunName: "",
      showuserListFlag: false,
      UserList: [],
      expanded: {},
      FilterUserList: [],
      selectedRunNames: [],
      selectedRunNamesCompare: [],
      selectedoutputFiles: [],
      selectedoutputFiles_Compare: [],
      selectedcommonAttribute: [],
      chooseJoin: "",
      chooseCommon: "",
      chooseOutput: "",
      chooseOutput_Compare: '',
      analyzeString: [],
      logDetail: [],
      count: 0,
      copied: false,
      value: '',
      sharefile: false,
      sharetinyurl: '',
      gettinylink: '',
      copylink: '',
      isRunActionOpen: false,
      parasetm: [],
      modalParameter: false,
      parasetc: [],
      comparemodalParameter:false,
      chatmasterId:"",
      chatMaster:"",
      chatrundata:[],
      chatprojectdata:[],
      badgeloading:false,
      projectDTOS:[],
      tags: [],
      randomcolor:'',
      DownloadUrl:'',
      myContent:'',
      fileType:'',
      jobIds:[],
      parasetTblState:[],
      parasetvalue:'',
      comparetbltext:"",
      suggestions: [],
      filterBy: "Runs",
      suggestions: [],
      value: "",
      tabId:"history",
      dropdownOpen: false,
      pagehist:'',
      checked: [],
      selected:[],
      selectedRows:[],
      compareRow:[],
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      SelectedHideCodes:[],
      parentRow:[],
      loadCatalogTab: false
    }

    this.OpenStorageView = this.OpenStorageView.bind(this);
    this.toggleRow = this.toggleRow.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }
  // with this function we create an array with the opened collapses
  // it is like a toggle function for all collapses from this page
  collapsesToggle = collapse => {
    let openedCollapses = this.state.openedCollapses;
    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: []
      });
    } else {
      this.setState({
        openedCollapses: [collapse]
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ pivotState: nextProps }); 
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener("ws-message-viewProject", this.eventListerForviewProject);
    removeDisableScroll();
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }

  callCompareTab = () =>{
    if(this.state.compareRow.length > 0){
      this.setState({
        chooseRunNameCompare:this.state.compareRow,
        selectedRunNamesCompare:this.state.compareRow})
    }
    else{
      this.setState({
        chooseRunNameCompare:[],
        selectedRunNamesCompare:[]
      })
    }
    }
 
  handleCallback = (childData) =>{
    this.setState({ram: childData})
    this.state.ram =childData
    let parseGetData= this.state.ram;
    let analyseData = {}
    parseGetData.map((item,index) => {
      analyseData[item.jobId] = true
  })
this.state.selected = analyseData
this.state.compareRow = parseGetData
}
  callRow = (event,rowInfo,nval) =>{
  

    event.preventDefault()
    let checkedrow =[]
    let remcheckId=rowInfo.Id;
  if (this.state.compareRow.some(item=>item.jobId === remcheckId) === false) {  // if id is not present ADD it
    if(rowInfo.hideCodeCells === true ){
      this.setState({hideCodeCells:"true"})
      }
     else{
      this.setState({hideCodeCells:"false"})
      }
    checkedrow = {
      label:rowInfo.Name.key + " _ " + rowInfo.Id,
      jobId:rowInfo.Id,
      id:rowInfo.DbId,
      value:rowInfo.DbId,
      runDbId:rowInfo.DbId,
      checkval:nval,
      checkName:rowInfo.Name.key,  
      name:rowInfo.Name.key,  
      modalcode: rowInfo.modelOutputCodeFiles ,
      output:rowInfo.OutputFile,
      parameter:rowInfo.parameterSet,
      runBy:rowInfo.createdBy,
      masterJobId:rowInfo.masterJobId,
      hideCodeCells:this.state.hideCodeCells,
      modelInput: rowInfo.InputFile,
      createdDate:rowInfo.StartTime.key
    }
      this.state.compareRow = [...this.state.compareRow, checkedrow];
      let analyseData = {}
      this.state.compareRow.map((item,index) => {
        analyseData[item.jobId] = true
    })
    this.setState({
      selected: analyseData,
    });
    this.handleCallback(this.state.compareRow)
    this.state.chooseRunNameCompare = this.state.compareRow;
    this.state.selectedRunNamesCompare = this.state.compareRow;
    this.rentData();  // To Load compare Table
    this.showotherActionCompare();   
  }
  else{
    this.setState(({compareRow}) => ({compareRow: compareRow.filter(item => item.jobId !== remcheckId)}));
    this.state.compareRow =this.state.compareRow.filter(item => item.jobId !== remcheckId)
    let analyseData = {}
    this.state.compareRow.map((item,index) => {
      analyseData[item.jobId] = true
  })
  this.setState({
    selected: analyseData,
  });
  this.handleCallback(this.state.compareRow)

  this.state.chooseRunNameCompare = this.state.compareRow;
  this.state.selectedRunNamesCompare = this.state.compareRow;
  this.rentData();  // To Load compare Table
  this.showotherActionCompare();   
  }

  }
  toggleRow(Id) {
  }
  handleCheckChange = () => {
    var selectAll = !this.state.selectAll;
    this.setState({ selectAll: selectAll });
    var checkedCopy = [];
    this.state.products.forEach(function(e, index) {
      checkedCopy.push(selectAll);
    });
    this.setState({
      checked: checkedCopy
    });
  };
  handleSingleCheckboxChange = (index) => {
    var checkedCopy = this.state.checked;
    checkedCopy[index] = !this.state.checked[index];
    if (checkedCopy[index] === false) {
      this.setState({ selectAll: false });
    }
    this.setState({
      checked: checkedCopy
    });
  };

  async loadOptions(search, prevOptions, { page, viewId, selvalue }) {
    let filteredOptions;
    let options = [];
    let results = [];
    let removevalues = [];
    let checkedvalues = selvalue
    if (!search) {
      filteredOptions = options;
    } else {
      const searchLower = search.toLowerCase();
      var runData = {};
      runData["jobIdOrNameStartsWith"] = searchLower
      runData["projectIds"] = [viewId]
      runData["runStatus"] = "Completed"
      const response =  await RunService.getRunSearch(runData, page, 20);
      let searchList = await response.runDetails.content !== null && await response.runDetails.content.length > 0 ? await response.runDetails.content : [];
      searchList.map((item, index) => {
          results.push({
            label: item.name + " _ " + item.jobId,
            jobId: item.jobId,
            id: item.id,
            description: item.description,
            value: item.runId,
            runDbId: item.id,
            createdDate: item.createdDate,
            input: item.inputSourceFiles,
            code: item.codeSourceFiles,
            modelInput: item.modelInputFiles,
            modelCodeFiles: item.modelCodeFiles,
            output: item.modelOutputFiles,
            modalcode: item.modelOutputCodeFiles,
            parameter: item.parameterSet,
            runTime: item.runTime,
            runBy: item.createdBy,
            logEntry: item.logFiles,
            masterJobId: item.masterJobId,
            hideCodeCells: item.hideCodeCells,
            name: item.name

          })
      })
      const results_temp = results;
      const results_checked = checkedvalues;
      const filterByReference = (results_temp, results_checked) => {
        let res = [];
        res = results_temp.filter(el => {
          return !results_checked.find(element => {
            return element.jobId === el.jobId;
          });
        });
        return res;
      }
      removevalues = filterByReference(results_temp, results_checked)

      filteredOptions = removevalues.filter(({ label }) =>
        label.toLowerCase().includes(searchLower)
      );
    }
    const hasMore = filteredOptions.length > prevOptions.length + 10;
    const slicedOptions = filteredOptions.slice(
      prevOptions.length,
      prevOptions.length + 10
    );

    return {
      options: slicedOptions,
      hasMore,
      additional: {
        page: page + 1,
        viewId: viewId,
        selvalue: selvalue
      },
    };
  }

  componentDidMount() {
    window.removeEventListener("ws-message-viewProject", this.eventListerForviewProject);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener('ws-message-viewProject', this.eventListerForviewProject);
    let currentUrl = window.location.href;
    var pathArray = window.location.pathname.split('?');
    let viewId = pathArray.toString().substring(pathArray.toString().lastIndexOf("/") + 1)

    this.state.pagehist = '/project'
    this.setState({
      viewId: viewId,
    },()=>{
      this.Initmethod();
    })
    addDisableScroll();
  }

  Initmethod = () =>{
    localStorage.removeItem("sharefilelink")
    localStorage.removeItem("filePathStorage")
    localStorage.removeItem("Pagehistory");
    this.GetAllProject();
    this.LoadrunsDetails();
    this.GetParticularProjectData(this.state.viewId);
  }


  eventListerForviewProject = (event) => {
      if (event !== undefined) {
        let noteData = event.detail.data;
        if (this.state.products.length > 0 && noteData !== undefined) {
          var productFilter = this.state.products.filter(item => item.Id === parseInt(noteData.runId))
          if (productFilter.length !== 0 || noteData.runStatus === RUN_PROGRESS_STATUS ) {
            jobStatusAlert(noteData.runId, noteData.runStatus, noteData.createdBy);
              this.setState({
                socketLoadFlag: true,
              }, () => {
                this.GetParticularProjectData(this.state.viewId);
              })
          } else {
            jobStatusAlert(noteData.runId, noteData.runStatus, noteData.createdBy)
          }
        }
      }
  }
 

  onDismiss = () => { };
  toggleModalParameter = (parasettbl,parasetvalue) => {
    this.setState({
      modalParameter: !this.state.modalParameter,
      parasetTblState:parasettbl,
      parasetvalue:parasetvalue
    });

   this.state.parasetTblState = parasettbl
   this.state.parasetvalue = parasetvalue
  }
  toggleCompareModalParameter = (parasetcompare) => {
    this.setState({
      comparemodalParameter: !this.state.comparemodalParameter,
      parasetc:parasetcompare
    });
  };
    //Get Run table data
    GetRunsData = (id) => {
      if (!this.state.socketLoadFlag) {
        this.setState({ loading: true });
      }
      let postData = {
        projectId: id
      }
      let size = 50;
      RunService.getRunbySize(postData,this.state.updatePageNumber,size)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let runSDTO = response.runDetails.content;
          this.renderData(runSDTO);
          this.setState({ loading: false, socketLoadFlag: false, jobIds:runSDTO, viewId: id,totalPages:response.runDetails.totalPages }
          ,()=>{
            jobidLoad(this.state.jobIds);
            projectLoad(this.state.projectDTOS);  // store project names for chat # features
          });// To load table data in to product array
        } else {
          this.setState({ loading: false, socketLoadFlag: false, viewId: id,totalPages:response.runDetails.totalPages });// To load table data in to product array    
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      })
    if (this.state.chatDbId != null) {
      this.LoadChats(this.state.chatDbId);
    }
    }
  //Get project table data
  GetParticularProjectData = (id) => {
    if (!this.state.socketLoadFlag) {
      this.setState({ loading: true });
    }
    ProjectService.GetProjectById(id).then((response) => {
      if (response.status === 'SUCCESS') {
          if(response.projectDTOS.length > 0) {
            let projectDTO = response.projectDTOS[0];
            this.state.viewname = projectDTO.name;
            this.state.chatMaster = projectDTO.chatMasterId;
          }
      }
    })
    let postData = {
      projectId: id
    }
    let size = 12;
    RunService.getRunbySize(postData,this.state.updatePageNumber,size)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let runSDTO = response.runDetails.content;
          this.renderData(runSDTO);
          this.setState({ loading: false, socketLoadFlag: false, jobIds:runSDTO, viewId: id,totalPages:response.runDetails.totalPages }
          ,()=>{
            jobidLoad(this.state.jobIds);
            projectLoad(this.state.projectDTOS);  // store project names for chat # features
          });// To load table data in to product array
        } else {
          this.setState({ loading: false, socketLoadFlag: false, viewId: id,totalPages:response.runDetails.totalPages });// To load table data in to product array    
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      })
    if (this.state.chatDbId != null) {
      this.LoadChats(this.state.chatDbId);
    }
  }

 displayUnreadCount (chatmasterId){
       let chatCount = 0;
       if(chatmasterId === null || chatmasterId === undefined){
          chatCount = 0;
        }else{
            var filterData = this.state.chatrundata.filter(f=>f.chatMasterId === chatmasterId);
            chatCount = filterData[0]!=undefined?filterData[0].totalUnreadMessages:0;          
          }
       return <span>{chatCount !== 0 && <sup><span className="badge badge-success">{chatCount}</span></sup>}</span>
     }

  CallJobRun = (jobrunid,chatMasterIdentifier) => { 
        let currentUrl = window.location.href;
        let reg = "/viewProject/"+this.state.viewId;
        localStorage.setItem("Pagehistory","Project");
        this.props.history.push("/job/"+chatMasterIdentifier+"?__o="+reg)    
          }

  addChip = (id,value,tags) => {
    var i= Math.floor(Math.random()*colours.length); 
    var getData = this.state.products.filter(item=>item.DbId === id);
    var index = this.state.products.findIndex(function(item, i){
      return item.DbId === id
    });
    getData[0].Tags.push(value)
    this.state.products[index]=getData[0];
    this.setState({products:this.state.products,
    randomcolor:colours[i]})
    this.CreateTags(id,tags);
  };
  getColor = () =>{
    let colorCode = getRandomRolor();
   return colorCode;
 }

  removeChip = (id,index) => {
    var getData = this.state.products.filter(item=>item.DbId === id);
    var productIndex = this.state.products.findIndex(function(item, i){
      return item.DbId === id
    });
    getData[0].Tags.splice(index,1)
    this.state.products[productIndex]=getData[0];
    this.setState({products:this.state.products})
    this.CreateTags(id,getData[0].Tags);
  };


  CreateTags = (id,tags) =>{
    RunService.createTags(id,tags)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          // toast.success("Tags Updated Successfully!");
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }

 
  handleAddRow = () => {
    const item = {
      key: "",
      value: ""
    };
    this.setState({
      parametersTablesdata: [...this.state.parametersTablesdata, item]
    });
  };
  //Display Run table

  renderData(runData) {
    let datas = [];
    let runs = []
    this.state.products = [];
    this.state.runOptions = [];
    runData.map((item, index) => {
      let parametersTables_array = []
      let parametersTables_files = item.parametersTables
       if (parametersTables_files !== null) {
        for (let index = 0; index < parametersTables_files.length; index++) {
          parametersTables_array.push(parametersTables_files[index])
        }
        this.setState({
          parametersTablesdata: parametersTables_array,
          parameterSet: item.parameterSet === null ? "":item.parameterSet
        });
      }
      else{
        this.setState({
          parametersTablesdata: [],
        });
      } 
      if (item.runStatus === "Completed") {
        runs.push({
          label: item.name + " _ " + item.jobId,
          jobId:item.jobId,
          id:item.id,
          description: item.description,
          value: item.runId,
          runDbId: item.id,
          input: item.inputSourceFiles,
          code: item.codeSourceFiles,
          output: item.modelOutputFiles,
          modalcode: item.modelOutputCodeFiles,
          parameter: item.parametersTables,
          parameterSet:item.parameterSet === null ? "":item.parameterSet,
          runTime: item.runTime,
          runBy: item.createdBy,
          logEntry: item.logFiles,
          hideCodeCells:item.hideCodeCells,

        })
      }
      if (item.runStatus === "Cancelled") {
        this.setState({ disabled: 'disabled' });
      } else if (item.runStatus === "Completed") {
        this.setState({ disabled: 'disabled' });
      } else if (item.runStatus === "Failed") {
        this.setState({ disabled: 'disabled' });
      } else {
        this.setState({ disabled: 'false' });
      }
      this.state.runname = item.name;
      let PrefixCodeFiles = [];

      if(item.codeFilesPrefix === null){
        PrefixCodeFiles = item.modelCodeFiles
      }else if(item.codeFilesPrefix.length > 0){
        var pre = item.codeFilesPrefix;
        var arr = item.modelCodeFiles
        var newArr = (pre + arr.join(';' + pre)).split(';');
        PrefixCodeFiles = newArr;
      }else{
        PrefixCodeFiles = item.modelCodeFiles
      }
      if(item.hideCodeCells === true ){
        this.setState({hideCodeCells:"true"})
        }
       else{
        this.setState({hideCodeCells:"false"})
        }
      datas.push({
        Name: 
        <span title={item.name} className="overflowStyle" key={item.name}>{item.name}</span>,
        fullName:item.name,
        Id: item.jobId, Description: item.description, 
        RunTime: <span className="overflowStyle">{millisecondToHour(item.runTimeInMilliseconds,item.runStatus)}</span>,
        Cluster: <span title={item.clusterName} className="overflowStyle">{item.clusterName}</span>,
        hideCodeCells: this.state.hideCodeCells,
        Status:
      
        <div key={item.runStatus}>

        {(item.runStatus === "Starting" || item.runStatus === "Progress") &&
          <Badge color="" className="badge-dot"><i className="bg-yellow blink" />{item.runStatus}</Badge>
        }
        {item.runStatus === "Executing" &&
          <Badge color="" className="badge-dot"><i className="bg-success blink" />{item.runStatus}</Badge>
        }
        {item.runStatus === "Cancelled" &&
          <Badge color="" className="badge-dot"><i className="bg-darkgray" />{item.runStatus}</Badge>
        }
        {item.runStatus === "Completed" &&
          <Badge color="" className="badge-dot"><i className="bg-blue" />{item.runStatus}</Badge>
        }
 {item.runStatus === "Failed" && 
                  <UncontrolledDropdown size="sm" className="float-right mt-2 statusmsg" id="runStatus" direction={(index > 6 ? "up" : "down")}>
                    <DropdownToggle
                    nav
                    tag="span"
                  >
                    <span className="websocketfontStyle"><Badge color="" className="badge-dot"><i className="bg-red" />{item.runStatus}</Badge>
                      &nbsp; &nbsp;<i className="fas fa-info-circle"></i></span>

                  </DropdownToggle>
                  {item.runFailedMsg !== null && item.errorName !== null && item.errorValue !== null ? <DropdownMenu
                    className="dropdown-menu-arrow popoverCard  p-3 rounded-lg h-auto df-run-failed"
                    top
                  >
                    { item.runFailedMsg === "Failed" && <>
                      <div className="err-title">
                        <p><span className="error-popup"><i className="fas fa-times df-text-white"></i></span>
                        <span className="text-capitalize p-1 error-icon">{item.errorName}</span></p>
                        <span onClick={e => this.closeErrorDialog()} className="actionicon"><i className="fas fa-times df-text-dark"></i></span>
                      </div>
                      <div className="err-content">
                          <span className="text-muted p-1 w-100 failedmsg text-left d-block">{item.errorValue}</span>
                        <Button className="err-button float-left"
                          onClick={e => {
                            e.preventDefault();
                            this.showLogPopup(item.jobId);
                          }}>Log</Button>

                        <Button className="err-button float-right"
                        onClick={e => 
                          item.modelOutputCodeFiles !== null && item.modelOutputCodeFiles !== undefined
                          && item.modelOutputCodeFiles.length > 0 ? this.OpenStorageView(item.modelOutputCodeFiles[0], e, item.hideCodeCells) : "" }
                      ><i className="fas fa-share-square"></i> Details</Button>
                      </div>
                      </>}
                      { item.runFailedMsg !== "Failed" && <>
                    <span className="text-capitalize p-2">No error message found</span>
                      </>}
                  </DropdownMenu> : <DropdownMenu
                    className="dropdown-menu-arrow popoverCard  p-3 rounded-lg h-auto df-run-failed noerror-message"
                    top
                  >
                    <span className="text-capitalize p-2">No error message found</span>
                  </DropdownMenu>}
                  </UncontrolledDropdown>
            }


      </div> ,
        hideCodeCells: item.hideCodeCells,
        Cost: item.cost ,
        DbId:item.id,
        scheduleId:item.scheduleId,
        createdBy: <span title={item.createdBy} className="overflowStyle">{item.createdBy}</span>,
        InputFile: item.modelInputFiles || [],
        InputFolders: item.modelInputFolders || [],  // new
        CodeFile: PrefixCodeFiles || [],
        CodeFolders: item.modelCodeFolders || [],  // new
        modelOutputCodeFiles: item.modelOutputCodeFiles != null?item.modelOutputCodeFiles:[],
        modelOutputCodeFolders: item.modelOutputCodeFolders != null?item.modelOutputCodeFolders:[],  //new
        OutputFile: item.modelOutputFiles != null?item.modelOutputFiles:[], 
        modelOutputFolders: item.modelOutputFolders != null?item.modelOutputFolders:[],   //new
        LogFiles: item.logEntries,
        Parameter: this.state.parametersTablesdata,
        parameterSet:item.parameterSet === null ? "":item.parameterSet,
        Tags:item.tags || [],
        StartTime: <div key={item.startTime}>	{item.startTime != null ? moment.utc(item.startTime).local().format('MMM DD, YYYY') : ""} <br></br>{item.startTime != null ? moment.utc(item.startTime).local().format('hh:mm A') : ""}<br /></div>, EndTime: <div key={item.endTime}>{item.endTime != null ? moment.utc(item.endTime).local().format('MMM DD, YYYY') : ""}<br></br> {item.endTime != null ? moment.utc(item.endTime).local().format('hh:mm A') : ""}</div>,
        Comments: <div className=""><button className="btn-icon-only text-blue" size="sm" role="button"
          color="" style={styles.chatbutton}
          onClick={e => this.CallJobRun(item.jobId,item.chatMasterIdentifier)}>

          <i className="far fa-comments text-blue" />
            {this.displayUnreadCount(item.chatMasterId)}
        </button>
        </div>,
        Action:
        <div className="">
        <div className="row">  
        <span className="actionicon" onClick={e => {
            e.preventDefault() 
            this.updateRerun(item.id, item.masterJobId)
            }}>Rerun | &nbsp;
        </span>
            <UncontrolledDropdown>
            <DropdownToggle tag="span" onClick={e => e.preventDefault()}
             style={{color: '#007bff',cursor:'pointer'}} >
              <i className="fas fa-ellipsis-v" />
              </DropdownToggle>
              <DropdownMenu
                className="dropdown-menu-arrow"
                right>
                {/* <DropdownItem
                  onClick={e => this.updateRerun(item.id, this.state.viewname)}
                >
                  <span id='Comments'>
                    <i className="fas fa-sync-alt text-red mr-3" /> Rerun
                </span>
                </DropdownItem> */}
                  <DropdownItem
                    href=""
                    className={this.state.disabledclone}
                    onClick={e => {e.preventDefault()
                  //  this.cloneProject(item.masterJobId,item.name)}}
                   this.cloneProject(item.id, item.masterJobId, item.name)}}
                   >
                 <span> 
                <i className="far fa-clone text-red mr-3" /> Clone as Project
                </span>
                 </DropdownItem>
                {/* <DropdownItem
                  href=""
                  disabled
                >
                  <span id='Comments'>
                    <i className="far fa-envelope-open text-red mr-3" /> Share by Email
                </span>
                </DropdownItem>
                <DropdownItem
                  href=""
                  // className={this.state.disabled}
                  disabled
                >
                  <span id='Comments' >
                    <i className="fas fa-chart-line text-red mr-3" /> View in Tableau
                                </span>
                </DropdownItem> */}
                <DropdownItem
                  onClick={e => this.jobCancelConfirmation(item.jobId, item.id)}
                  className={this.state.disabled}
                >
                  <input type="hidden" value={item.id} id="itemid" ></input>
                  <span id='Comments'>
                    <i className="fas fa-times text-red mr-3" /> Cancel Job
                                </span>
                </DropdownItem>
                <DropdownItem
                    onClick={e => this.jobRemoveConfirmation(item.jobId, item.id)}
                >
                  <input type="hidden" value={item.id} id="removeid" ></input>
                  <span id='Comments'> <i className="fas fa-archive text-red mr-3"></i>
                                 Remove Job
                                </span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
</div>
          </div>

      })
    });
    this.setState({
      products: datas,
      runOptions: runs
    });
  }
  jobRemoveConfirmation = (jobId, removeId) => {
    confirmAlert({
      title: 'Remove Job',
      message: 'Are you sure to remove this job -' + jobId + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.RemoveAction(removeId)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }

  updateRerun = (id, project_id) => {
    let reg = "/viewProject/";
    localStorage.setItem("Pagehistory", "viewProject");
    this.props.history.push({
      pathname: '/newProject/'+ "?__o=" + reg,
      state: { mode: "reRun", rerunId: id, runName: project_id ,chatmasterId:this.state.chatmasterId,viewId:this.state.viewId,
      projectId: project_id}
    })
  }
  
  cloneProject = (id,masterJobId,name) =>{
    let reg = "/viewProject/";
    localStorage.setItem("Pagehistory", "viewProject");
    this.props.history.push({
      pathname: '/newProject/'+ "?__o=" + reg+ this.state.viewId ,
     state: { mode:"cloneProject",cloneId: id,editId:masterJobId,editProject:name,viewId:this.state.viewId,runName:name,chatmasterId:this.state.chatmasterId,from:'runs'}
    })
  }
  openDialog = (itemid) => {
    this.setState({ isDialogOpen: true })
  }
  // Handling remove job actions
  RemoveAction = (rid) => {
    if (rid !== undefined && rid !== null) {
      let RemoveJobdto = {
        id: rid
      }
      RunService.removeJob(RemoveJobdto)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            this.GetParticularProjectData(this.state.viewId); // Reload runs data
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
        });
    }
  }
  handleChange = (event) => {
    this.setState({ input: event.target.value });
  }
  handleDelete = (item) => {
    var index_user = this.state.input_user.indexOf(item);
    var index_email = this.state.input_userEmail.findIndex(obj => obj['user'] === item);
    this.state.input_user.splice(index_user, 1);
    this.state.input_userEmail.splice(index_email, 1);
    this.setState({
      input_user: this.state.input_user,
      input_userEmail: this.state.input_userEmail
    })
    if (this.state.input_user.length === 0) {
      let uId = localStorage.getItem("Uid");
      this.GetAllUsers(uId);
    }
  };
  userselectedValue = (firstName, lastName, email) => {
    let myappendUser = "@" + firstName + " " + lastName
    let selectedEmail = { user: myappendUser, email: email };
    const filteredArray = this.state.UserList.filter((res) => res.firstName !== firstName);
    this.setState({
      input: "",
      input_userEmail: [...this.state.input_userEmail, selectedEmail],
      input_user: [...this.state.input_user, myappendUser],
      UserList: filteredArray
    })
  }
  keyPressed = (event) => {
    if (event.keyCode === 13) {
      this.submitMessage()
    } else if (event.keyCode === 50) {
      this.setState({ showuserListFlag: true });
    }
  }
  onPageChange(pageIndex) {
    this.setState({
      updatePageNumber:pageIndex
    },()=>{
      this.LoadrunsDetails(); // Load chat run data
      if(this.state.filtered.length!=0){
        this.filterMethod(this.state.filtered)
      }else{
        this.GetParticularProjectData(this.state.viewId)
      }
    });
  }
  submitMessage = () => {
    let emailList = [];
    for (let i = 0; i < this.state.input_userEmail.length; i++) {
      emailList.push(this.state.input_userEmail[i].email);
    }
    let chatPaylad = {
      "runDBId": this.state.chatDbId,
      "message": this.state.input_user + " " + this.state.input,
      "mentionedUsers": emailList
    }
    RunService.Postchat(chatPaylad)
      .then((response) => {
        this.setState(
          {
            messages: [...this.state.messages, this.state.input_user + " " + this.state.input],
            input: "",
            input_user: [],
            input_userEmail: []
          }
        );
      })
    let uId = localStorage.getItem("Uid");
    this.GetAllUsers(uId);
  }
  clearMessages = () => {
    this.setState({ messages: [] });
  }
  handleClose = () => {
    this.setState({ isDialogOpen: false, logState: false, isRemoveDialogOpen: false, modalParameter:false,comparemodalParameter:false})
  }
  // cancel job
  jobCancelConfirmation = (jobId, cancelId) => {
    confirmAlert({
      title: 'Cancel Job',
      message: 'Are you sure to cancel this job -' + jobId + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.HandlingAction(cancelId)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }
   _onScrollLoadMessage(){
    if(localStorage.getItem("scrollMount")==='false'){
       this.LoadOlderMessagesByProject(this.state.chatmasterId);
    }
  }
  async _onMessageWasSent(message) {
    let loggedInUser = JSON.parse(localStorage.getItem("UserProfile"));
    let chatPayload;
    let res = {
      "firstName": loggedInUser.firstName,
      "lastName": loggedInUser.lastName,
      "photoURL": null,
      "message": message.data,
      "createdDate": moment().format(),
    }

    if (message.files.length === 0) {  // Text message
      this.setState({
        messageList: [...this.state.messageList, res],
      })
      chatPayload = {
        "messageType": message.type,
        "message": message.data,
        "mentionedUsers": message.emails,
        "chatMasterId": this.state.chatMaster
      }
      RunService.Postchat(chatPayload)
        .then((response) => { });

    } else { // media message
      res["mediaBase64Content"] = message.mediaBase64Content;
      this.setState({
        messageList: [...this.state.messageList, res],
      })
      chatPayload = {
        // "messageType": message.type,
        "message": message.data,
        // "mentionedUsers":message.emails,
        "chatMasterId": this.state.chatMaster,
        "contentType": "application/png"
      }

      ChatService.PostMedia(chatPayload, message.files)
        .then((response) => { });
    }
  }

  // Handling cancel job actions
  HandlingAction = (uid) => {
    if (uid !== undefined && uid !== null) {
      let JobPayload = {
        id: uid
      }
      RunService.cancelJob(JobPayload)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            this.GetParticularProjectData(this.state.viewId); // Reload runs data
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
        });
    }
  }

  FilterData = () => {
    this.setState({ count: this.state.count + 1 });
    if (this.state.count % 2 === 0) {
      this.setState({ filter: true, filtered: [] });
    }
    else {
      this.setState({ filter: false }, () => { this.GetRunsData() });
    }
  }

  // Download particular file in input or code
  downloadparticularFiles = (fileName, rid, type) => {
    StorageService.downloadObjectUrl(fileName)
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.download_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }
  // Hide and Show Log for each run
  HideandShowLog(flag,fileName, log) {
    this.setState({ modalloading:true ,myContent:''});
  let filepath = "jobs/"+fileName+"/logs/console.log"
    StorageService.downloadObjectUrl(filepath)
    .then((response) => {
      this.renderText(response.download_url);
      this.setState( { modalloading:false,DownloadUrl:response.download_url} );
    }).catch((error) => {
      this.setState({ modalloading:false });
    });;
    this.setState({
      logState: !flag,
      isDialogOpen: true,
      logDetails: log
    })
  }
  renderText = (url) => {
    axios.get(url)
    .then(response => {
    this.setState({
      fileType:"others",
      myContent:response.data.toString()
      })
    })
    .catch(error => {
      return error;
    });
}

  GetAllProject = () => {
    ProjectService.GetProject(0, 50)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let responseData = response.projectDTOSPage;
          if (responseData.content !== null) {
            this.setState({
              projectDTOS: responseData.content
            });
          }
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      });
  }

  onOpenModal = () => {
    localStorage.setItem("messagePageNumber",0);
    this.setState({
      open: true,
      chatmasterId:this.state.chatMaster
    },()=>{
      this.LoadMessagesByProject(this.state.chatmasterId);
    });
  };
  LoadrunsDetails = () =>{
    ChatService.GetChatRunIds(this.state.updatePageNumber,10).then((response) => {
    if(response !== ""){  // if chat response is 204 execure this condtion
      this.setState({chatrundata:response.chatItems});
    }
    });
  }

  LoadMessagesByProject = (chatmasterId) =>{
     this.setState({
      badgeloading:true
    })
    let size = 20;
    // Get message page number from chatwindow scroll
    ChatService.GetChatMessages(chatmasterId,localStorage.getItem("messagePageNumber"),size).then((chatResponse) => {
      if(chatResponse === "" || chatResponse === ""){  // if chat response is 204 execure this condtion
            this.setState({
              messageList: [],
              badgeloading:false
            })
      }else{
        this.setState({
          messageList: chatResponse.chat.reverse(),
          badgeloading:false
            })
      }
     });  
  }

    LoadOlderMessagesByProject = (chatmasterId) =>{
    this.setState({
      badgeloading:true
    })
    let size = 20;
    ChatService.GetChatMessages(chatmasterId,localStorage.getItem("messagePageNumber"),size).then((chatResponse) => {
        if(chatResponse === "" || chatResponse === ""){
          this.setState({
            messageList: this.state.messageList,
            badgeloading:false
          })
        }else{
          let chat = chatResponse.chat.reverse();
          for(var i=0;i<chat.length;i++){
            this.setState({
                messageList: [chat[i]].concat(this.state.messageList),
                badgeloading: false
            })
          }
        }  
     });  
  }

  onCloseModal = () => {
    this.setState({ open: false });
  };

  // Load all chats for particular run id
  LoadChats = (runId) => {
    let profile = JSON.parse(localStorage.getItem("UserProfile"));
    this.setState({
      localName: profile.firstName + " " + profile.lastName,
      localPhoto: profile.photoURL,
      input: '',
      messages: []
    });
    RunService.GetChats(runId)
      .then((response) => {
        this.setState({
          chatMsg: response
        })
        let uId = localStorage.getItem("Uid");
        this.GetAllUsers(uId);
      })
  }

  GetAllUsers = (allid) => {
    let uid = {
      id: allid
    }
    UserService.getAllUsers(this.state.usersid)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let loggedInUser = JSON.parse(localStorage.getItem("UserProfile"));
          let users = []
          let i;
          for (i = 0; i < response.userDTOS.length; i++) {
            if (loggedInUser.email !== response.userDTOS[i].email) {
              users.push(response.userDTOS[i])
            }
          }
          this.setState({
            UserList: users
          });

        } else {
          // console.log(response.errorMessage);
        }
      })
  }

  handleChangeRun = (event) => {
    if (event != null) {
      this.setState({
        chooseRunName: event[0].value,
        selectedRunNames: event
      });
      // console.log(this.state.selectedRunNames)
    } else {
      this.setState({
        steptwoFlag: false,
        selectedRunNames: []
      });
    }
  }

  constructArray = (valuesArray, hidecodeArray) => {
    let tableValues = [];
    for (var cA = 0; cA < valuesArray.length; cA++) {
      let NewValue = {
        displayName: valuesArray[cA],
        hideCodeFlag: hidecodeArray[cA]
      }
      tableValues.push(NewValue)
    }
    return tableValues;
  }

  rentData = () => {
    let SelectrunIds = [];
    let SelectedJOBId = [];
    let SelectedList = [];
    this.state.parentRow =this.state.selectedRunNamesCompare;
    if(this.state.selectedRunNamesCompare.length > 0){
        for(let i=0;i<this.state.selectedRunNamesCompare.length;i++){
          SelectrunIds.push(this.state.selectedRunNamesCompare[i].id)
          SelectedJOBId.push(this.state.selectedRunNamesCompare[i].jobId)
          SelectedList.push(this.state.selectedRunNamesCompare[i])
        }    
        ProjectService.CompareProject(SelectrunIds)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            let tableCompareDTO = response.compareDTOS;
            const filteredRunDataFolders = tableCompareDTO.filter(item => item.keyName==="modelInputFolders");
            const filteredRunData = tableCompareDTO.filter(item => item.keyName === "name" || item.keyName === "description" || item.keyName === "hideCodeCells"
            || item.keyName==="parameterSet" || item.keyName==="modelInputFiles" || item.keyName==="modelCodeFiles"
            || item.keyName==="modelOutputFiles" ||item.keyName==="modelOutputCodeFiles" || item.keyName==="createdBy" || item.keyName==="runTime");
            
            var len = filteredRunData.length;
            let hideCodesArray = filteredRunData.filter(item => item.keyName === "hideCodeCells");
            let hideCodesValuesArray = hideCodesArray[0].values;
            let tableData = [];
            for (const run of filteredRunData) {
              let tableVal = {
                keyName: run.keyName,
                values: this.constructArray(run.values, hideCodesValuesArray)
              }
              tableData.push(tableVal);
            }
            this.setState({
              tableCompareData:tableData
            })   
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
     });
     this.handleCallback(this.state.selectedRunNamesCompare)
    }
      else{
        this.setState({ 
          tableCompareData:[],
          tableCompareFlag: false,
          selectedRunNamesCompare:[],
          chooseRunNameCompare:[],
          compareRow:[]
        })
        this.state.tableCompareData=[]
        this.state.tableCompareFlag= false;
        this.state.selectedRunNamesCompare=[]
        this.state.chooseRunNameCompare=[]
        this.state.compareRow=[]
      this.handleCallback(this.state.selectedRunNamesCompare)

    }
  }
  handleChangeRunCompare = (event) => {
    if (event != null) {
         this.setState({
        tableCompareFlag: true,
        chooseRunNameCompare: event.value,
        chooseOutput_Compare:'',
        chooseOutput:'',
        selectedoutputFiles:[],
        selectedoutputFiles_Compare:[],
        selectedRunNamesCompare: event
      }, () => {
        this.rentData();  // To Load compare Table
        this.showotherActionCompare();
      });
    }  else {
      this.setState({
        // viewId:'',
        steptwoFlag: false,
        tableCompareFlag: false,
        tableCompareData:[],
        selectedRunNamesCompare: [],
        selectedoutputFiles_Compare: [],
        graphFlag: false,
        chooseRunNameCompare:[],
        compareRow:[]
      }, () => {
         this.rentData(); 
         this.showotherActionCompare();
      });
      this.state.tableCompareData=[]
      this.state.tableCompareFlag= false;
      this.state.selectedRunNamesCompare=[]
      this.state.chooseRunNameCompare=[]
      this.state.compareRow=[]
    }
  }

  onSelectOutput = (fileName) => {
    this.setState({
      chooseOutput: fileName
    });
  }

  onSelectOutput_Compare = (fileName) => {
    this.setState({
      chooseOutput_Compare: fileName
    });
  }

  handleChangeJoin = (event) => {
    this.setState({
      chooseJoin: event.value
    });
  }
  handleChangeCommon = (event) => {
    if (event != null) {
      this.setState({
        chooseCommon: event[0].value,
        selectedcommonAttribute: event
      });
    } else {
      this.setState({
        steptwoFlag: false,
        selectedcommonAttribute: []
      });
    }
  }

  ChangeTab = (tabValue) => {
    this.setState({
      products: []
    })
    tabValue === "two" || tabValue === "Compare" ?
      console.log("tab changed") : this.GetParticularProjectData(this.state.viewId);
  }

  CancelFlagTwo = () => {
    this.setState({
      products: []
    })
  }

  OpenStorageView = (name, event, hidevalue) => {
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl1 = window.location.href;
    var parts = currentUrl1.split("/");
    let fromwhere = parts[parts.length-1]
    let currentUrl = '';
    if(fromwhere === 'project'){
    currentUrl = currentUrl1.replace('?__o=/project','');
    }
    else{
    currentUrl = currentUrl1.replace('/?__o=/runs','');
    }
    let reg = "/viewProject/" + this.state.viewId;  
    let path = name.slice(-1) === "/"?"/storage?path="+name:"/storageView?file="+name + "&hideCodeCells=" + hidevalue; // check folder or file
    let redirectUrl = currentUrl.replace(reg, path);
    window.open(redirectUrl, "_blank");
  }

  copyAlert = () => {
    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied!</b></i>); 
  }

  GetLink = (name, event,from) => {
    this.setState({ loading: true })
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl1 = window.location.href;
    var parts = currentUrl1.split("/");
    let fromwhere = parts[parts.length-1]
    let currentUrl = '';
    if(fromwhere === 'project'){
    currentUrl = currentUrl1.replace('?__o=/project','');
    }
    else{
    currentUrl = currentUrl1.replace('/?__o=/runs','');
    }
    let reg = "/viewProject/" + this.state.viewId;
    let redirectUrl = currentUrl.replace(reg, "/storageView?file=" + name);

    TinyURL.shorten(redirectUrl).then((res) =>{
      this.setState({ copiedtxt: res })
      var tempInput = document.createElement("input");
      tempInput.value = this.state.copiedtxt;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
        if(from === "modelinput"){
           this.setState({ copiedmodelinput: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        }  else if(from === "modelcode"){
           this.setState({ copiedmodelcode: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        }  else if(from === "modeloutputfile"){
           this.setState({ copiedmodeloutputfile: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        }   else if(from === "modeloutputcodefile"){
           this.setState({ copiedmodeloutputcodefile: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        }   
        else if(from === "tablecompare"){
           this.setState({ copiedtablecompare: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        }  
        else if(from === "tablecompare2"){
           this.setState({ copiedtablecompare: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        } 
        else{
          this.setState({ comparetbltext: "Shareable link Copied" })
          setTimeout(() => {
            this.closeerror();
            this.setState({ comparetbltext: "" })

           },1000);
        }
 
    })
  }
  closeerror =() =>{
    this.setState({ loading:false,copiedmodelinput: "" ,copiedmodelcode:"", copiedmodeloutputfile:"", copiedmodeloutputcodefile:"",copiedtablecompare:"",comparetbltext:""})
}
  showotherActionCompare = () => {
    let outFiles = [];    
    this.state.selectedRunNamesCompare.forEach((activity) => {
      activity.output!=null?activity.output.forEach((data) => {
        var leafName = data.split('/').pop()
        if (outFiles.indexOf(leafName) !== -1) {
        } else {
          outFiles.push(leafName);
        }
      }):console.log("");
      this.setState({
        steptwoFlag: true,
        selectedoutputFiles_Compare: outFiles
      })
    });
    if(this.state.selectedRunNamesCompare.length === 0){
      this.state.tableCompareData=[]
      this.state.selectedRunNamesCompare=[]
      this.state.chooseRunNameCompare=[]
      this.state.compareRow=[]
      this.state.tableCompareFlag= false;
    }
  }
  showotherAction = () => {
    let outFiles = [];
    let commonAttrip = [];
    this.state.selectedRunNames.forEach((activity) => {
      activity.output.forEach((data) => {
        if (outFiles.indexOf(data.fileName) !== -1) {
        } else {
          outFiles.push(data.fileName);
        }
      });
      this.setState({
        steptwoFlag: true,
        selectedoutputFiles: outFiles
      })
    });

    this.state.selectedRunNames.forEach((activity1) => {
      activity1.output.forEach((data) => {
        data.outputHeaders.forEach((finalData) => {
          let myUnique = commonAttrip.filter(item => item.value === finalData);
          if (myUnique.length != 0) {
            // console.log("already exists")
          } else {
            commonAttrip.push({
              value: finalData,
              label: finalData
            });
          }
        })
      });
      this.setState({
        commonOptions: commonAttrip
      })
    });

  }
  CompareData = () => {
    if(this.state.selectedRunNamesCompare.length > 0) {
      this.setState({
        tableCompareFlag: true,
        loading: true ,
        graphFlag_Loading: true,
        graphText: "Pivot Table Loading..."
      }, () => {
        //  this.rentData();  // To Load compare Table
      })
    }
    let dbIds = this.state.selectedRunNamesCompare.map(x => x.runDbId.toString());
    let commAttributes = this.state.commonOptionsCompare.map(x => x.toString());
    let param = {
      commonAttributes: commAttributes,
      fileName: this.state.chooseOutput_Compare === ""?this.state.selectedoutputFiles_Compare[0]:this.state.chooseOutput_Compare,
      joinType: "outer",
      runDBIds: dbIds
    }
    this.ToLoadGraph(param)
  }
  // Download compare file
  downloadCompareFile = () =>{
    let dbIds = this.state.selectedRunNamesCompare.map(x => x.runDbId.toString());
    let commAttributes = this.state.commonOptionsCompare.map(x => x.toString());
    let param = {
      commonAttributes: commAttributes,
      fileName: this.state.chooseOutput_Compare === ""?this.state.selectedoutputFiles_Compare[0]:this.state.chooseOutput_Compare,
      joinType: "outer",
      runDBIds: dbIds
    }
    let fileName  = this.state.selectedRunNamesCompare[0].label+"_"+new Date().getTime();
    ProjectService.CompareDownload(param).then((response) => {
      saveDownloadFile(response,fileName)
      });  
  }
  SubmitJoin = () => {
    this.setState({
      graphFlag_Loading: true,
      graphText: "Pivot Table Loading..."
    });
    let dbIds = this.state.selectedRunNames.map(x => x.runDbId.toString());
    let commAttributes = this.state.selectedcommonAttribute.map(x => x.value.toString());
    let param = {
      commonAttributes: commAttributes,
      fileName: this.state.chooseOutput === ""?this.state.selectedoutputFiles[0]:this.state.chooseOutput,
      joinType: this.state.chooseJoin,
      runDBIds: dbIds
    }
    this.ToLoadGraph(param)
  }
  ToLoadGraph(graphData) {
    let records = []
    let dataItems = []
    let delimiter = ","
    ProjectService.AnalyzeProject(graphData)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          delimiter = response.delimiter
          if (response.output !== null) {
            dataItems = response.output.split("\n")

            for (let i = 0; i < dataItems.length; i++) {
              let actualItems = dataItems[i].split(delimiter)
              let items = dataItems[i].split(delimiter).map(Number);
              let processedItem = []
              for (let j = 0; j < items.length; j++) {
                let value = items[j]
                if (isNaN(value)) {
                  processedItem.push(actualItems[j])
                } else {
                  processedItem.push(value)
                }
              }
              records.push(processedItem)
            }
          }
          this.setState({
            loading: false, 
            mode: 'demo',
            graphFlag: true,
            graphFlag_Loading: false,
            graphText: '',
            filename: 'Sample Dataset: Tips',
            pivotState: {
              data: records, //response.records,
              plotlyOptions: { width: 900, height: 500 },
              plotlyConfig: {},
              tableOptions: {
                clickCallback: function (e, value, filters, pivotData) {
                  var names = [];
                  pivotData.forEachMatchingRecord(filters, function (
                    record
                  ) {
                    names.push(record.Meal);
                  });
                },
              },
            },
          });


        } else {
          this.setState({
            loading: false, 
            graphFlag: false,
            graphFlag_Loading: true,
            graphText: "Pivot Table Data Failed"
          })
        }
      });
  }
  changeColumnName = (column) => {
    let ColumnName = ""
    if (column === "Name") { ColumnName = "name" }
    if (column === "RunTime") { ColumnName = "runTime" }
    if (column === "Cluster") { ColumnName = "clusterName" }
    if (column === "Id") { ColumnName = "jobId" }
    if (column === "Status") { ColumnName = "runStatus" }
    if (column === "StartTime") { ColumnName = "startTime" }
    if (column === "EndTime") { ColumnName = "endTime" }
    if (column === "createdBy") { ColumnName = "createdBy" }
    return ColumnName;
  } 

  filterMethod = (filter) => {
    this.setState({ filtered: filter }, () => {
      if (this.state.filtered.length === 2) {
        this.state.filtered.splice(0, 1);
      }
    })
    if (filter.length != 0) {
      if (filter[filter.length - 1].id === "Id" && filter[filter.length - 1].value.length > 1) {
        this.filterDataLoadDelay(filter, this.state.updatePageNumber)
      } else if (filter[filter.length - 1].id === "RunTime" && filter[filter.length - 1].value.length > 1) {
        this.filterDataLoadDelay(filter, this.state.updatePageNumber)
      } else if (filter[filter.length - 1].value.length > 2) {
        this.filterDataLoadDelay(filter, this.state.updatePageNumber)
      }
    } else {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.GetParticularProjectData(this.state.viewId);
      }, 1500);
    }
  }

  filterDataLoadDelay = (filter,pageNumber) =>{
    if(this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        //search function
        this.filterDataLoad(filter,pageNumber)

      }, 300);
  }


  async filterDataLoad(filter, pageNumber) {
    let size = 15;
    var runData = {};
    if(this.changeColumnName(filter[filter.length - 1].id) === "name" || this.changeColumnName(filter[filter.length - 1].id) === "jobId"){
      runData["jobIdOrNameStartsWith"] = filter[filter.length - 1].value
    }else{
      runData[this.changeColumnName(filter[filter.length - 1].id)] = filter[filter.length - 1].value
    }
    runData["projectIds"] = [this.state.viewId]
    if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
      this.searchTimeOut = await new Promise(resolve => setTimeout(resolve, INTERVALSEARCH));
      const response = await RunService.getRunSearch(runData, pageNumber, size);
      if (response.status === 'SUCCESS') {
        let runSDTO = response.runDetails.content;
        this.renderData(runSDTO);
        this.setState({ loading: false, socketLoadFlag: false, totalPages: response.runDetails.totalPages });// To load table data in to product array
      } else {
        this.setState({ loading: false, socketLoadFlag: false, totalPages: response.runDetails.totalPages });// To load table data in to product array
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
  };

  showLogPopup = (jobId) => {
    document.getElementById("runStatus").click();
    this.HideandShowLog(this.state.logState, jobId, null)
  }


  searchBy = (value) => {
    this.setState({
      filterBy: value,
      value: "",
    })
    this.GetRunsData(this.state.viewId);
  }
  onChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue
    });
    if (newValue === "") {
      this.GetRunsData(this.state.viewId);
    }
  };
  onChangeTags = (event, { newValue, method }) => {
    this.setState({
      value: newValue
    });
    if (newValue === "") {
      this.GetRunsData(this.state.viewId);
    }
  };
  onSuggestionsRunsFetchRequested = ({ value }) => {
    let page = 0;
    let limit = 20;
    let tagOption = [];

    if (value === "") {
      this.GetRunsData(this.state.viewId);
    }
    var runData = {};
    runData["jobIdOrNameStartsWith"] = value
    runData["projectIds"] = [this.state.viewId]
    RunService.getRunSearch(runData, page, limit)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let myTags = response.runDetails.content;
          this.setState({
            tagDTOS: myTags,
            searchtagdata: myTags,
          });
          for (let i = 0; i < myTags.length; i++) {
            tagOption.push({
              name: myTags[i].name + " _ " + myTags[i].jobId,
              value: myTags[i].jobId,
            })
          }
          this.setState({ loading: false, suggestions: tagOption });
          this.setState({ loading: false });
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  onSuggestionRunsSelected = (event, { suggestion, suggestionValue, index, method }) => {
    event.preventDefault();
    let page = 0;
    let limit = 20;
    var runData = {};
    runData["jobIdOrNameStartsWith"] = suggestion.value
    runData["projectIds"] = [this.state.viewId]
    RunService.getRunSearch(runData, page, limit)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let myProject = response.runDetails.content;
          this.renderData(myProject);
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  onSuggestionsTagFetchRequested = ({ value }) => {
    let page = 0;
    let limit = 50;
    let tagOption = [];
    if (value === "") {
      this.GetRunsData(this.state.viewId);
    }
    RunService.GetRunTags(value, page, limit)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let myTags = response.tagListAutoComplete;
          this.setState({
            tagDTOS: myTags,
            searchtagdata: myTags,
          });
          for (let i = 0; i < myTags.length; i++) {
            tagOption.push({
              name: myTags[i],
              value: myTags[i],
            })
          }
          this.setState({ loading: false, suggestions: tagOption });
          this.setState({ loading: false });
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  onSuggestionTagSelected = (event, { suggestion, suggestionValue, index, method }) => {
    event.preventDefault();
    RunService.GetRunTagsValue(suggestion.name)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let myProject = response.runDTOS;
          this.renderData(myProject);
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  toggleDropDown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }
  onClickSchedulerId = (id) => {
    this.props.history.push("/schedule?id="+id+"&scheduleFor=runs")
  }

  closeErrorDialog = () => {
    document.getElementById("closeDialog").click();
  }

  handleClick = (e) => {
    e.preventDefault();
      if(e.type === "contextmenu") {
        var arrt = e.currentTarget.getAttribute("data_attr_id");
        document.getElementById(arrt).click();
    }  
  }

  render() {
    const { suggestions,value } = this.state;
    const inputPropsruns = {
      placeholder: "Search By Runs",
      value,
      onChange: this.onChange,
      id: "SRuns",
    };
    const inputPropstags = {
      placeholder: "Search By Tags",
      value,
      onChange: this.onChangeTags,
      id: "STag",
    };
    return (
    
        <>
          <PanelHeader
            content={
              <div className="header text-center">
              </div>
            }
          />
          <div className="content" id="closeDialog">
          <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
        />}
      >
            <Row>
              <Col xs={12} md={12}>
                <Card>
                  <CardHeader>
                    <Row className="align-items-center">
                      <div className="col">
                        <span className="text-center"><b>Project : </b> &nbsp;{this.state.viewname}</span>
                      </div>
                      <div className="col text-right">
                          <i className="fas fa-sync-alt mr-5 text-primary pointer-cursor" onClick={e => this.GetParticularProjectData(this.state.viewId)} /> 
                        <Link to={this.state.pagehist} > 
                          <span className="close clear-filter">×</span>
                        </Link>
                       
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                  <div className="carcontent">
                  <Scrollbars autoHeight autoHeightMin={this.state.sheight-160}>

                    <Tabs
                      defaultTab="history"
                      onChange={(tabId) => { this.setState({tabId:tabId}) }}>
                      <TabList>
                    <Row>
                      <div className="col-4">
                        <Tab tabFor="history" className="add-data-tab tabcolor">Run History</Tab>
                        <Tab tabFor="Compare" className="add-data-tab tabcolor" onClick={this.callCompareTab}>Compare</Tab>
                        <Tab tabFor="catalog" className="add-data-tab tabcolor" onClick={() => { this.setState({ loadCatalogTab: true }) }}>Catalog</Tab>
                      </div>
                        <div className="col-6">
                      {this.state.tabId === "history" && <div>
                        <InputGroup className="prosrch">
                          <InputGroupButtonDropdown addonType="append" isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown}>
                            <DropdownToggle caret>
                              {this.state.filterBy}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={e => this.searchBy('Runs')}>Runs &nbsp;</DropdownItem>
                              <DropdownItem divider />
                              <DropdownItem onClick={e => this.searchBy('Tags')}>Tags &nbsp;</DropdownItem>
                            </DropdownMenu>
                          </InputGroupButtonDropdown>
                          {this.state.filterBy === "Runs" &&
                            <Autosuggest
                              suggestions={suggestions}
                              onSuggestionsFetchRequested={this.onSuggestionsRunsFetchRequested}
                              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                              getSuggestionValue={getSuggestionValue}
                              renderSuggestion={renderSuggestion}
                              onSuggestionSelected={this.onSuggestionRunsSelected}
                              inputProps={inputPropsruns} />
                          }
                          {this.state.filterBy === "Tags" &&
                            <Autosuggest
                              suggestions={suggestions}
                              onSuggestionsFetchRequested={this.onSuggestionsTagFetchRequested}
                              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                              getSuggestionValue={getSuggestionValue}
                              renderSuggestion={renderSuggestion}
                              onSuggestionSelected={this.onSuggestionTagSelected}
                              inputProps={inputPropstags} />

                          }
                        </InputGroup>
                        </div>
                        }
                      </div>
                      <div className="col-2">
                        <i className="far fa-comments text-blue" onClick={e=>this.onOpenModal()} style={{cursor:"pointer",color:"#4b88da",float:"right",marginTop:25}}/>
                     </div>
                     </Row>
                      </TabList>
                      <TabPanel tabId="history">
                        <ReactTable
                          onFilteredChange={filtered => this.filterMethod(filtered)}
                          getTrProps={(state, rowInfo) => {
                            if (rowInfo && rowInfo.row) {
                              return {
                                onClick: e => {
                              },
                                style: {
                                  background: this.state.selected[rowInfo.row.Id] === true ? 'rgb(223 227 233)' : 'white',
                                  color:this.state.selected[rowInfo.row.Id] === true ? 'black' : 'black'
                                }
                              }
                            }else{
                              return {
                            
                              }
                            }
                          }}
                          filtered={this.state.filtered}
                          data={this.state.products}
                          expanded={this.state.expanded}
                          PaginationComponent={Pagination}
                          manual
                          onExpandedChange={(expanded, index, event) => {
                          this.setState({expanded});            
                        }}
                          columns={
                            [
                              {
                                Header: "",
                                columns: [
                                  {
                                    expander: true,
                                    Header: () => <strong className="filterdata" onClick={e => this.FilterData()}>&nbsp; &nbsp; &nbsp;<i className="fas fa-filter"></i> </strong>,
                                    width: 60,
                                    Expander: ({ isExpanded, ...rest }) =>
                                      <div>
     {isExpanded
                                      ? <span style={{verticalAlign:"text-bottom"}}>-</span>
                                      : <span style={{verticalAlign:"text-bottom"}}>+</span>}
                                      </div>,
                                    style: {
                                      cursor: "pointer",
                                      fontSize: 20,
                                      padding: "0",
                                      textAlign: "center",
                                      userSelect: "none"
                                    },
                                  }
                                ]
                              },
                              {
                                id: "checkbox",
                                accessor: "",
                                Cell: ({ original}) => {
                                  return (   
                                    <input
                                      type="checkbox"
                                      className="checkbox"
                                      disabled={original.Status.key === "Completed" ? false : true}
                                      title="Select to Compare"
                                      checked={this.state.selected[original.Id] === true}
                                      onChange={() => this.toggleRow(original.Id)}
                                      onClick = { (e) => {this.state.selected[original.Id] === true ? this.callRow(e,original,'false') : this.callRow(e,original,'true')}}
                                    />
                                
                                  );
                                },
                                sortable: false,
                                width: 45,
                              
                              },
                              {
                                id: "scheduler",
                                accessor: "",
                                Cell: ({ original}) => {
                                  return (   
                                  original.scheduleId !== null && <i className="far fa-clock" title="Scheduled Run" style={{verticalAlign:"baseline",color:"#4776d9"}}/>
                                  );
                                },
                                sortable: false,
                                width: 20,
                              
                              },
                              {
                                Header: 'Name',
                                accessor: 'Name',
                                maxWidth: 400,
                                filterable: this.state.filter,
                                // sortable: true,
                                // filterable: false
                              },
                              {
                                Header: 'Tags',
                                accessor: 'Tags',
                                show:false
                                },
                                {
                                  Header: 'fullName',
                                  accessor: 'fullName',
                                  show: false
                              
                                },      
                                {
                                  Header: 'DbId',
                                  accessor: 'DbId',
                                  show:false
                                  },
                              {
                                Header: 'Id',
                                accessor: 'Id',
                                maxWidth: 70,
                                filterable: this.state.filter,
                                // sortable: true,
                                // filterable: false
                              }
                              , {
                                Header: 'Description',
                                accessor: 'Description',
                                show: false
                              }, {
                                Header: 'RunTime',
                                accessor: 'RunTime',
                                maxWidth: 120,
                                filterable: this.state.filter,
    
                              }, {
                                Header: 'Cluster',
                                accessor: 'Cluster',
                                maxWidth: 80,
                                filterable: this.state.filter,
                              },
                              {
                                Header: 'Status',
                                accessor: 'Status',
                                maxWidth: 100,
                                filterable: this.state.filter,
                              }, {
                                Header: 'StartTime',
                                accessor: 'StartTime',
                                filterable: this.state.filter,
                              }, {
                                Header: 'EndTime',
                                accessor: 'EndTime',
                                filterable: this.state.filter,
                              },
                              {
                                Header: 'scheduleId',
                                accessor: 'scheduleId',
                                show: false
                              },
                              {
                                Header: 'hideCodeCells',
                                accessor: 'hideCodeCells',
                                show: false
                              },
                              {
                                Header: 'Cost',
                                accessor: 'Cost',
                                sortable: true,
                                filterable: this.state.filter,
                                maxWidth: 100
                              }, {
                                Header: 'createdBy',
                                accessor: 'createdBy',
                                maxWidth: 400,
                                filterable: this.state.filter,
                              }, {
                                Header: 'Comments',
                                accessor: 'Comments',
                                maxWidth: 80
                              },
                              // {
                              //   Header: 'Re-Run',
                              //   accessor: 'Rerun',
                              //   maxWidth: 70
                              // },
                              {
                                Header: 'Action',
                                accessor: 'Action',
                                maxWidth: 70
                              },
                              {
                                Header: 'InputFile',
                                accessor: 'InputFile',
                                show: false
                              },
                              {
                                Header: 'CodeFile',
                                accessor: 'CodeFile',
                                show: false
                              },
                              {
                                Header: 'InputFolders',
                                accessor: 'InputFolders',
                                show: false
                              },
                              {
                                Header: 'CodeFolders',
                                accessor: 'CodeFolders',
                                show: false
                              },
                              {
                                Header: 'modelOutputCodeFolders',
                                accessor: 'modelOutputCodeFolders',
                                show: false
                              },
                              {
                                Header: 'modelOutputFolders',
                                accessor: 'modelOutputFolders',
                                show: false
                              },
                              {
                                Header: 'OutputFile',
                                accessor: 'OutputFile',
                                show: false
                              }, {
                                Header: 'modelOutputCodeFiles',
                                accessor: 'modelOutputCodeFiles',
                                show: false
                              },
                              {
                                Header: 'Parameter',
                                accessor: 'Parameter',
                                show: false
                              },
                              {
                                Header: 'parameterSet',
                                accessor: 'parameterSet',
                                show: false
                              },
                              {
                                Header: 'LogFiles',
                                accessor: 'LogFiles',
                                show: false
                              },
                            
                            ]
    
                          }
                          defaultSorted={[
                            {
                              id: "StartTime",
                              desc: true
                            }
                          ]}
                      defaultPageSize={12}
                      pages={this.state.totalPages}
                      onPageChange={this.onPageChange}
                          SubComponent={(v) => <div>
                            <br />
                            <Row>
                            <Col lg="1"><span><b>Name :</b></span></Col>
                            <Col lg="3"><span >{v.row.fullName}
                            </span></Col>
                            <Col lg="4"><span><b>Description :</b>&nbsp; &nbsp; &nbsp; {v.row.Description}</span></Col>
                            <Col lg="4">{v.row.scheduleId !== null &&<span style={{marginLeft:10}} onClick={e=>this.onClickSchedulerId(v.row.scheduleId)}><a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="far fa-clock pr-1" style={{ color: "#4776d9"}}></i>Scheduler Details</u> </a></span>}</Col>                            </Row>
                            <br />
                            <Row>
                           <Col lg="1" style={{marginTop:10}}><span><b>Tags :</b></span></Col>
                           <Col lg="10">
                           <Scrollbars autoHeight autoHeightMin={50} autoHeightMax={150}>
                           {v.row.Tags.map((item, index) => (
                           <Chip
                            key={"tag-file-" + index}
                            label={item}
                            id={uuidv4()} 
                            size="small"
                            onDelete={(chip) => this.removeChip(v.row.DbId,index)}
                            style={{background:this.getColor(),color:"#fff",fontWeight:600,marginTop:5,marginLeft:3}}
                          />))}
                           <ChipInput
                              value={v.row.Tags}
                              id={uuidv4()} 
                              placeholder="Add a Tag"
                              onAdd={value => this.addChip(v.row.DbId,value,v.row.Tags)}
                            />
                             </Scrollbars><br/>
                             {/* <TagsInput value={v.row.Tags} onChange={evt => this.handleChangeTags(v.row.DbId, evt)}/> <br/> */}
                             {/* <Button className="tag-update-btn" onClick={e => this.CrateTags(v.row.DbId,v.row.Tags)}>Update</Button> */}
                             </Col>
                             <Col lg="1"></Col>
                           </Row>
                           <br />
                            <div>{(v.row.InputFile.length != 0 || v.row.InputFolders.length > 0) &&
                          <span ><br /> <b>Model Input Files : &nbsp;<span style={styles.error}>{this.state.copiedmodelinput}</span></b> 
                          <br />
                            <Table id={uuidv4()}>
                              <tbody style={{border:'none'}}>
                                <tr>
                                  <td>
                            <div className={(v.row.InputFile.length + v.row.InputFolders.length) > 7 ? "scorllit" : ""}>
                            <ul id={uuidv4()}>
                            {v.row.InputFolders.map((item, index) => (
                              <li style={{marginTop:10}} className="listyle" id={uuidv4()} 
                              onContextMenu={e => e.preventDefault()}>
                              <span
                              className="file"
                              data-type="folder"
                              onClick={e => this.OpenStorageView(item, e, v.row.hideCodeCells)}
                              >
                                <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                              </span>
                              </li>
                            ))}
                            </ul>
                            {v.row.InputFile.map((item,index) => (
                              <ul key={"in-file-" + index}>
                                <li className="listyle">
                                <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                <span className="file" data-type="file" data_attr_id={"codeId"+index+"v"}
                                  onContextMenu={this.handleClick}>
                                  <span className="text-primary"><i
                                      className={getImageFile(imageFileExtension(item))}></i></span>
                                  <a href={()=> false} className="text-primary" style={styles.chaticon} ><u>{item}</u>
                                  </a>
                                </span>
                                    <DropdownToggle tag="span" id={"codeId"+index+"v"}>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                      <DropdownItem
                                        onClick={e => this.OpenStorageView(item, e, v.row.hideCodeCells)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
          </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
          </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.GetLink(item, e,'modelinput')}>
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>
                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                  </li>
                              </ul>
                            ))}
                            </div>
                        </td>
                        </tr>
                        </tbody>
                      </Table>
                     </span>
                        }
                        </div>
                            <br />
                            <div>{(v.row.CodeFile.length > 0 || v.row.CodeFolders.length > 0) &&
                          <span ><b>Model Code Files : &nbsp;<span style={styles.error}>{this.state.copiedmodelcode}</span></b> 
                          <br />
                           <Table>
                           <tbody style={{border:'none'}}>
                                <tr><td>
                               <div className={(v.row.CodeFile.length + v.row.CodeFolders.length) > 7 ? "scrollit" : ""}>
                               <ul>
                                 {v.row.CodeFolders.map((item, index) => (
                                   <li key={"code-fol-" + index} style={{marginTop:10}} className="listyle"
                                   onContextMenu={e => e.preventDefault()}>
                                   <span
                                   className="file"
                                   data-type="folder"
                                   onClick={e => this.OpenStorageView(item, e, v.row.hideCodeCells)}
                                   >
                                     <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                   </span>
                                   </li>
                                 ))}
                                </ul>
                            {v.row.CodeFile.map((item,index) => (
                              <ul key={"code-file-" + index}>
                                <li className="listyle">
                                <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                <span
                                        className="file"
                                        data-type="file"
                                        data_attr_id={"codeId"+index+"w"}
                                        onContextMenu={this.handleClick}
                                      > 
                                         <span className="text-primary"><i className={getImageFile(imageFileExtension(item))}></i></span>
                                        <a href={() => false} className="text-primary" style={styles.chaticon} ><u>{item}</u> </a>
                                      </span>
                                    <DropdownToggle tag="span" id={"codeId"+index+"w"}>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                      <DropdownItem
                                        onClick={e => this.OpenStorageView(item, e, v.row.hideCodeCells)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => { this.GetLink(item, e,'modelcode') }}
                                      >
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>
                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </li>
                              </ul>
                            ))}
                            </div>
                            </td>
                            </tr>
                            </tbody>
                            </Table>
                          </span>
                         }
                        </div>
                            <br />
                            <div>{v.row.OutputFile.length != 0 &&
                          <span ><b>Model Output Files :  &nbsp;<span style={styles.error}>{this.state.copiedmodeloutputfile}</span></b> 
                          <br />
                            <Table>
                            <tbody style={{border:'none'}}>
                                <tr><td>
                                  <div className={(v.row.OutputFile.length + v.row.modelOutputFolders.length) > 7 ? "scrollit" : ""}>
                               <ul>
                                 {v.row.modelOutputFolders.map((item, index) => (
                                   <li key={"modeout-fold-" + index} style={{marginTop:10}} className="listyle"
                                   onContextMenu={e => e.preventDefault()}>
                                   <span
                                   className="file"
                                   data-type="folder"
                                   // onClick={onFileClick}
                                   onClick={e => this.OpenStorageView(item, e, v.row.hideCodeCells)}
                                   >
                                     <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                   </span>
                                   </li>
                                 ))}
                                </ul>
                            <div>
                            {v.row.OutputFile.map((item,index) => (
                              <ul key={"modelout-file-" + index}>
                                <li className="listyle">
                                <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                <span className="file" data-type="file" data_attr_id={"codeId"+index+"x"}
                                  onContextMenu={this.handleClick}>
                                  <span className="text-primary"><i
                                      className={getImageFile(imageFileExtension(item))}></i></span>
                                  <a href={()=> false} className="text-primary" style={styles.chaticon} ><u>{item}</u>
                                  </a>
                                </span>
                                    <DropdownToggle tag="span" id={"codeId"+index+"x"}>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                      <DropdownItem
                                        onClick={e => this.OpenStorageView(item, e, v.row.hideCodeCells)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.GetLink(item, e,'modeloutputfile')}
                                      >
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>
                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </li>
                              </ul>
                            ))}
                             </div>
                             </div>
                             </td>
                             </tr>
                             </tbody>
                             </Table>
                          </span>
                        }
                        </div>
                            <br />
                            <div>{v.row.modelOutputCodeFiles.length != 0 &&
                          <span ><b>Model Output Code Files :  &nbsp;<span style={styles.error}>{this.state.copiedmodeloutputcodefile}</span></b> <br />
                          <br />
                             <Table>
                             <tbody style={{border:'none'}}>
                                <tr><td>
                                <div className={(v.row.modelOutputCodeFiles.length + v.row.modelOutputCodeFolders.length) > 7 ? "scrollit" : ""}>
                               <ul>
                                 {v.row.modelOutputCodeFolders.map((item, index) => (
                                   <li key={"modelcode-fold-" + index} style={{marginTop:10}} className="listyle"
                                   onContextMenu={e => e.preventDefault()}>
                                   <span
                                   className="file"
                                   data-type="folder"
                                   // onClick={onFileClick}
                                   onClick={e => this.OpenStorageView(item, e, v.row.hideCodeCells)}
                                   >
                                     <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                   </span>
                                   </li>
                                 ))}
                                </ul>
                            <div>
                            {v.row.modelOutputCodeFiles.map((item,index) => (
                              <ul key={"moc-files-" + index}>
                                <li className="listyle">
                                  <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                  <span className="file" data-type="file" data_attr_id={"codeId"+index+"y"}
                                    onContextMenu={this.handleClick}>
                                    <span className="text-primary"><i
                                        className={getImageFile(imageFileExtension(item))}></i></span>
                                    <a href={()=> false} className="text-primary" style={styles.chaticon} ><u>{item}</u>
                                    </a>
                                  </span>
                                    <DropdownToggle tag="span" id={"codeId"+index+"y"}>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                    <DropdownItem
                                        onClick={e => this.OpenStorageView(item, e, v.row.hideCodeCells)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.GetLink(item, e,'modeloutputcodefile')}
                                      >
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>
                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </li>
                              </ul>
                            ))}
                            </div>
                            {/*{v.row.modelOutputCodeFiles.length > 7  && <div className="scrollit">
                            {v.row.modelOutputCodeFiles.map((item,index) => (
                              <ul>
                                <li><span>
                                <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                    <DropdownToggle tag="span" onClick={e => e.preventDefault()} style={{ color: '#007bff ' }}>
                                      <span
                                        className="file"
                                        data-type="file"
                                      // onClick={onFileClick}
                                      >
                                        <a className="text-primary" style={styles.chaticon} ><u>{item.filePath}</u> </a>
                                      </span>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                      <DropdownItem
                                        onClick={e => this.OpenStorageView(item.filePath, e)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item.filePath, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.GetLink(item.filePath, e)}
                                      >
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>
                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </span></li>
                              </ul>
                            ))}
                            </div>}*/}
                            </div>
                         </td>
                         </tr>
                         </tbody>
                         </Table>
                          </span>
                        }
                        </div>
                            <Row>
                              <Col lg="2">{v.row.Parameter.length > 0 && <span><b>Business Levers :</b></span>}</Col>
                              <Col lg="4"><span > {
                                <Scrollbars autoHeight>
                                  <div>
                                  {v.row.Parameter.length > 0 && <span> 
                          {
                            <Scrollbars autoHeight>
                               {v.row.Parameter.length > 0 &&
                              <Table responsive className="table-hover paratbl"
                          id="tab_logic"
                        >
                          <thead>
                            <tr>
                              <th>Variables </th>
                              <th style={{ width: "80%" }}> Values </th>
                            </tr>
                          </thead>
                          <tbody>
                            {v.row.Parameter.map((item, index) => (
                              item.row !== false &&
                              <tr id="addr0" key={index}>
                                <td className="variabletxt">{item.key}</td>
                                <td style={{ width: "80%" }}>
                                  <Input
                                    className="form-control-alternative valuetxt"
                                    defaultValue={item.value}
                                    style={{ border: 'none', borderRadius: '5px' }}
                                    id={uuidv4()} 
                                    disabled
                                    name="parameterSet"
                                    type="text"
                                  />
                                </td>
                              </tr>
                            ))}
                          
                          </tbody>
                        </Table>     
                      }
                     {v.row.Parameter.length  === 0 && <span style={{color: 'darkgray', fontSize: '14px'}}>  &nbsp; No Business Levers Found</span>}
                            </Scrollbars>
                          }
                          </span>
                      }
                                  </div>
                                </Scrollbars>
                              }</span></Col>
                              <Col lg="4">
                            {/* {v.row.Parameter != "" && v.row.Parameter != null && <img src={openpara} onClick={e => this.toggleModalParameter(v.row.Parameter)} style={{ cursor: 'pointer', width: '30px', height: '30px' }} />
                            } */}
                             {v.row.Parameter.length > 0 && 
                          <img src={openpara} onClick={e => this.toggleModalParameter(v.row.Parameter,v.row.parameterSet)} style={{ cursor: 'pointer', width: '30px', height: '30px' }} />
                          }
                          </Col>
                            </Row>
                            <br />
                            <div>
                             <span ><b>Log :</b>{
                              this.state.logState === false ?
                                <Button style={styles.logbtn} onClick={e => this.HideandShowLog(this.state.logState,v.row.Id, v.row.LogFiles)}>Show</Button> :
                                <Button style={styles.logbtn} onClick={e => this.HideandShowLog(this.state.logState,v.row.Id, v.row.LogFiles)}>Hide</Button>
                            }
                            </span>
                            </div>
                          </div>

                          }
                          className="-striped -highlight tableHeight"
                        />
                        <div>{this.state.logState && <Dialog
              title="Logs"
              modal={true}
              onClose={this.handleClose}
            >
         <LoadingOverlay
        active={this.state.modalloading}
        spinner={<HashLoader
          size={50}
          color={"#fff"}
          loading={this.state.modalloading}
        />}
      >
              <Scrollbars style={styles.expandStyles_Comman} autoHeight autoHeightMin={400}
                thumbMinSize={30} >
                  {(this.state.fileType === "others") &&
                       <p style={{ marginLeft: 5, fontSize: "0.70rem", marginBottom: 10, lineHeight: 2 }}>
                  {this.state.myContent.split("\n").map((i, key) => {
                    return <div key={"mycons-" + key}>{i}</div>;
                  })}
                </p> 
                        } 
              </Scrollbars>
              </LoadingOverlay>
            </Dialog>}
            </div>


            <Modal isOpen={this.state.modalParameter} toggle={this.handleClose} className="parameter-modal" style={{maxWidth:'700px'}}
            backdrop="static">
                           <ModalBody>
                                                <div>
                                                <div className="reactmodalbody">
              <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={600} >
                              <div>

                  <Tabs defaultTab="Default View" onChange={(tabId) => { 
                    // console.log(tabId)
                     }}>
                    <TabList>
                      <Row>
                        <div className="col">
                          <Tab tabFor="Default View" className="adddatatab"> Default View</Tab>
                          <Tab tabFor="Detailed View" className="adddatatab"> Detailed View</Tab>
                        </div>
                        <div className="col text-right">
                          <span style={{ cursor: 'pointer' }} onClick={e => this.handleClose()}>
                            <i className="fas fa-times text-red mr-3"></i>
                          </span>
                        </div>
                      </Row>
                    </TabList>
                    <TabPanel tabId="Default View">
                      <CardBody>
                        <Table responsive className="table-hover paratbl" id="tab_logic">
                          <thead>
                            <tr>
                              <th>Variables </th>
                              <th style={{ width: "80%" }}> Values</th>
                            </tr>
                          </thead>
                          <tbody>
                          {/* {this.state.parasetTblState > 0 && */}
                            {this.state.parasetTblState.map((item, index) => (
                              item.row !== false &&
                              <tr id="addr0" key={index}>
                                <td className="variabletxt">{item.key}</td>
                                <td style={{ width: "80%" }}>
                                  <Input
                                    className="form-control-alternative valuetxt"
                                    defaultValue={item.value}
                                    disabled
                                    style={{ border: 'none', borderRadius: '5px' }}
                                    id={uuidv4()} 
                                    name="parameterSet"
                                    type="text"
                                  />
                                </td>
                              </tr>
                            ))}
                            {/*  } */}
                          </tbody>
                        </Table>
                      </CardBody>
                    </TabPanel>
                    <TabPanel tabId="Detailed View">
                      <CardBody>
                        <div>
                          <FormGroup>
                            <Editor
                            className="codeStyleDetailView"
                            value={this.state.parasetvalue}
                            disabled
                            id="textAreaParamm"
                            name="parameterSet"
                            highlight={code => highlight(code, languages.py)}
                            padding={10}
                          />
                          </FormGroup>
                        </div>
                      </CardBody>
                 </TabPanel>
                  </Tabs>
                </div>
              </Scrollbars>         
            </div>
                                                </div>
                                              </ModalBody>
                                            </Modal>
                        <Modal isOpen={this.state.open} toggle={this.onCloseModal} className="chatProjectModal" 
                        backdrop="static">
                            <ModalHeader className="ModalHeader" toggle={this.onCloseModal}>Comments</ModalHeader>
                          { this.state.badgeloading === true &&  <div className="chatLoading text-center">
                            <Badge color="info" >Loading...</Badge>
                          </div>}      
                          <Launcher
                            agentProfile={{
                            }}
                            onMessageWasSent={this._onMessageWasSent.bind(this)}
                            messageList={this.state.messageList}
                            _onScrollLoadMessage={this._onScrollLoadMessage.bind(this)}
                            showEmoji
                          />                       
                        </Modal>
                        {/*run history end*/}
                      </TabPanel>
                      <TabPanel tabId="Compare">
                      {this.state.tabId === "Compare" &&
                       <div>
                        <Card className="card-plain">
                          <CardHeader role="tab">
                            <a
                              aria-expanded={this.state.openedCollapses.includes(
                                "collapseOne"
                              )}
                              href="#pablo"
                              data-parent="#accordion"
                              data-toggle="collapse"
                              onClick={e => {
                                e.preventDefault();
                                this.collapsesToggle("collapseOne");
                              }}
                            >
                              Search or Select Runs to Compare &nbsp;&nbsp;

                              <i className="now-ui-icons arrows-1_minimal-down" />
                            </a>
                              <div style={{float:"right"}}><button className="btn-icon-only text-blue" size="sm" role="button"
                                color="" style={styles.chatbutton}
                              ></button>
                                {/* <i className="far fa-comments text-blue" onClick={e=>this.onOpenModal()} style={{cursor:"pointer",color:"#4b88da"}}/> */}
                                </div>
                          </CardHeader>
                          <Collapse
                            role="tabpanel"
                            isOpen={this.state.openedCollapses.includes(
                              "collapseOne"
                            )}
                          >
                            <CardBody>
                              <Row>
                                <Col lg="5">
                                  <FormGroup>
                                    <h6 style={{ padding: "20px" }}> Step 1 - Select Runs </h6>
                                      <AsyncPaginate
                                        isMulti
                                        closeMenuOnSelect={false}
                                        placeholder="Search by Run Name or JobID"
                                        loadOptions={this.loadOptions}
                                        value={this.state.chooseRunNameCompare}
                                        onChange={this.handleChangeRunCompare}
                                        additional={{
                                          page: 0,
                                          viewId:this.state.viewId,
                                          selvalue:this.state.selectedRunNamesCompare
                                          // results:[],
                                         // more:true
                                        }}
                                      />
                                  </FormGroup>
                                </Col>
                                <Col lg="1">
                                </Col>
                                <Col lg="6">
                                  {this.state.selectedoutputFiles_Compare.length != 0 && <Card>
                                    <h6 style={{ padding: "20px" }}> Output </h6>
                                    <FormGroup>
                                      <Row>
                                        <Col xs={12}>
                                          {this.state.selectedoutputFiles_Compare.map((item, index) => (
                                            <ul className="listyle" id={uuidv4()}>
                                              <li><span ><input type="radio" name="input_file"
                                                onChange={e => this.onSelectOutput_Compare(item)} defaultChecked={index === 0} /><a href={() => false} className="text-primary" style={styles.chaticon}>&nbsp;&nbsp;&nbsp;{item}</a></span>
                                              </li>
                                            </ul>
                                          ))}
                                        </Col>
                                      </Row>
                                      <br></br>

                                    </FormGroup>
                                  </Card>}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="4">

                                </Col>

                                <Col lg="4">
                                  <Row>
                                    <Col xs={12}>
                                      <CardBody>
                                        <div className="btns-mr-5">
                                          <FormGroup>
                                            <Button color="primary"
                                              onClick={e => this.CompareData()}
                                              size="md">Compare / Show Data </Button>
                                          </FormGroup>
                                        </div>
                                      </CardBody>
                                    </Col>
                                  </Row>
                                </Col>

                                <Col lg="4">

                                </Col>
                              </Row>
                              <br />
                            </CardBody>
                          </Collapse>
                        </Card>
                        {/*secondend*/}
                        {/*pivot chart  start*/}
                        <Card className="card-plain">
                          <CardHeader role="tab">
                            <a
                              aria-expanded={this.state.openedCollapses.includes(
                                "collapseTwoCompare"
                              )}
                              href="#pablo"
                              data-parent="#accordion"
                              data-toggle="collapse"
                              onClick={e => {
                                e.preventDefault();
                                this.collapsesToggle("collapseTwoCompare");
                              }}
                            >
                              Data Compare &nbsp;&nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                            </a>
                            {this.state.graphFlag && <i className="fas fa-download mr-2 compare-dl-icon" onClick={e=> this.downloadCompareFile()}/>}
                          </CardHeader>
                          <Collapse
                            role="tabpanel"
                            isOpen={this.state.openedCollapses.includes(
                              "collapseTwoCompare"
                            )}
                          >
                            <CardBody>
                              <Row>
                                <Col lg="12">
                                <Scrollbars autoHeight  autoHeightMax={800} >
                                  {this.state.graphFlag && this.state.pivotState.data !== undefined && <PivotTableUI
                                    renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}

                                    {...this.state.pivotState}
                                    onChange={s => this.setState({ pivotState: s })}
                                    unusedOrientationCutoff={Infinity}
                                  />}
                                  {this.state.graphFlag_Loading && <span style={{ justifyContent: "center", textAlign: "center" }}>{this.state.graphText}</span>}
                                  </Scrollbars>
                                </Col>
                              </Row>
                            </CardBody>
                          </Collapse>
                        </Card> 
                        {/*pivot chart  end*/}
                        {/*Table view*/}
                        <Card className="card-plain">
                          <CardHeader role="tab">
                            <a
                              aria-expanded={this.state.openedCollapses.includes(
                                "collapseTwoCompareTable"
                              )}
                              href="#pablo"
                              data-parent="#accordion"
                              data-toggle="collapse"
                              onClick={e => {
                                e.preventDefault();
                                this.collapsesToggle("collapseTwoCompareTable");
                              }}
                            >
                              Table Compare &nbsp;&nbsp; 
                          <i className="now-ui-icons arrows-1_minimal-down" />
                          &nbsp;&nbsp;  <b><span style={styles.error}>{this.state.comparetbltext}</span></b>
                            </a>
                          </CardHeader>
                          <Collapse
                            role="tabpanel"
                            isOpen={this.state.openedCollapses.includes(
                              "collapseTwoCompareTable"
                            )}
                          >
                            <CardBody>
                              <Row>
                                <Col lg="12">
                                &nbsp;<b><span style={styles.error}>{this.state.copiedtablecompare}</span></b> <br />
                                {this.state.tableCompareFlag === true && 
                     <Table responsive className="table-striped">
                      <tbody>
                              {this.state.tableCompareData.map(item => (
                                <tr>
                                  <th>{item.keyName === "hideCodeCells" ? " " : item.keyName}</th>
                                  {!item.keyName.includes("Files") ?
                                    item.values.map(function (iString) {
                                      return <td>{iString.displayName}</td>
                                    }) :item.values.map(function (keyPair) {
                                      return <td>
                                        {keyPair.displayName.map(innerArray => (<UncontrolledDropdown direction="right">
                                          <DropdownToggle tag="span" onClick={e => e.preventDefault()} style={{ color: '#007bff ' }}
                                           onContextMenu={e => e.preventDefault()}>
                                            <span
                                              className="file"
                                              data-type="file"
                                            >
                                              <div>
                                                <p>
                                                  <i className={getImageFile(imageFileExtension(innerArray))}></i>
                                                  <a href="# " className="text-primary" style={styles.chaticon} ><u>{innerArray}</u> </a>
                                                </p>
                                              </div>
                                            </span>
                                          </DropdownToggle>
                                          <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                            <DropdownItem
                                              onClick={(e) => this.OpenStorageView(innerArray, e, keyPair.hideCodeFlag)} >
                                              <span >
                                                <i className="fas fa-binoculars mr-2"></i> View
                                              </span>
                                            </DropdownItem>
                                            <DropdownItem
                                              onClick={e => this.downloadparticularFiles(innerArray, keyPair.runId, keyPair.inputType)}
                                            >
                                              <span>
                                                <i className="fas fa-download mr-2" /> Download
                                              </span>
                                            </DropdownItem>
                                            <DropdownItem
                                              onClick={e => this.GetLink(innerArray, e, 'tablecompare2')}>
                                              <div>
                                                <i className=" fas fa-link mr-2" />
                                                <span>Get Sharable Link</span>
                                              </div>
                                            </DropdownItem>
                                          </DropdownMenu>
                                        </UncontrolledDropdown>))}
         </td>
                                    }, this)
                                  }
                                </tr>
                              ))}
                            </tbody>
                     </Table>
  }
                                </Col>
                              </Row>
                            </CardBody>
                          </Collapse>
                        </Card>
                        {/*Table View end*/}
                        </div>
  }
                      </TabPanel>
                      {this.state.loadCatalogTab ?
                            <TabPanel key={this.state.chooseRunNameCompare?.length} tabId="catalog">
                              <Catalog key={this.state.chooseRunNameCompare?.length} selected={this.state.chooseRunNameCompare} />
                            </TabPanel>
                      : null}
                    </Tabs>
                    </Scrollbars>

                  </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            </LoadingOverlay>

          </div>
  
            
        </>
    );
  }
}

export default ViewProject;
